// store.js
import React, { createContext, useReducer } from "react";

const initialState = { user: {}, analytics: {} };
const store = createContext(initialState);
const { Provider } = store;
const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case "SET_USER_DATA":
        let userState = { ...state.user, ...action.payload };
        return { ...state, user: userState };
      case "SET_EMAIL_DATA":
        let userEmailData = { ...state.email, ...action.payload };
        return { ...state, emailData: userEmailData };
      case "SET_ACCESS_TOKEN":
        return { ...state, accesstoken: action.payload };
      case "SET_GA":
        return { ...state, analytics: action.payload };
      case "CLEAR_ERROR":
        return { ...state, user: { ...state.user, error: {} } };
      case "SET_CONTRASTE":
        return { ...state, contrast: action.payload };
      default:
        throw new Error();
    }
  }, initialState);
  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { store, StateProvider };
